import { FC, useRef, useEffect, useState, PropsWithChildren } from "react";
import { shallowEqual, useSelector, connect, ConnectedProps, useDispatch } from "react-redux";
import { LayoutSplashScreen } from "../../../../_metronic/layout/core";
import * as auth from "./AuthRedux";
import { getUserByToken } from "./AuthCRUD";
import { RootState } from "../../../../setup";
import { UserModel } from "services/api/cplauthapi/CPLAuthAPI";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { IMaintenanceService } from "services/MaintenanceService";
import { setCPLMaintenanceDates } from "app/system/maintenance/MaintenanceSlice";
import { IAuthState } from "./AuthRedux";

const mapState = (state: RootState) => ({ auth: state.auth });
const connector = connect(mapState, auth.actions);
type PropsFromRedux = ConnectedProps<typeof connector>;

const AuthInit: FC<PropsWithChildren<PropsFromRedux>> = (props) => {
  const didRequest = useRef(false);
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const authState = useSelector<RootState, IAuthState>(({ auth }) => auth, shallowEqual);
  const dispatch = useDispatch();

  // We should request user by authToken before rendering the application
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const user: UserModel = await getUserByToken(authState.token!);
          props.setUser(user);
        }
      } catch (error) {
        console.error(error);
        if (!didRequest.current) {
          props.logout();
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    const initAuth = async () => {
      const maintenanceService = container.get<IMaintenanceService>(SERVICE_TYPES.MaintenanceService);
      const maintenanceDates = await maintenanceService.getMaintenanceDates();
      const convertedDates = maintenanceService.convertMaintenanceDates(maintenanceDates);

      dispatch(setCPLMaintenanceDates(convertedDates));

      const isDownForMaintenance = maintenanceService.checkIfDownForMaintenance(convertedDates);

      if (isDownForMaintenance) {
        setShowSplashScreen(false);
        return;
      }

      if (authState.token) {
        requestUser();
      } else {
        props.logout();
        setShowSplashScreen(false);
      }
    };

    if (!authState.externalAccess) {
      initAuth();
    } else {
      setShowSplashScreen(false);
    }

    // eslint-disable-next-line
  }, []);

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
};

export default connector(AuthInit);
